export default __webpack_public_path__ + "static/media/bottom2 1.b443a1d6.png";